<template>
  <div>
    <div class="container">
      <vs-col
        v-for="(table, index) in tables"
        :key="index"
        class="table-cont"
        vs-w="4"
      >
        <div class="title-wrapper" @click="() => handleOnSelectTable(table)">
          <p class="name">{{ table.title }}</p>
        </div>
      </vs-col>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TablesList",
  components: {},
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  props: {
    tables: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleOnSelectTable(table) {
      this.$emit("onTableSelected", table);
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  display: grid;
  grid-template-columns: auto auto auto;
  margin: 0;
  padding: 0;
  gap: 2px;

  .table-cont {
    margin: 0;
    padding: 0;
    float: left;
    position: relative;
    border-radius: 2px;
    height: 45px;
    cursor: pointer;
    background-color: #e0e0e0;
    width: 100% !important;

    .title-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .name {
        font-size: 12px;
        font-weight: 700;
      }
    }
  }
}
</style>
